import React, { useState } from 'react';
import FileInput from '../FileInput';

const DragAndDrop = ({ onFileSelect, onFileDrop }) => {

    const [fileName, setFileName] = useState('');

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file) {
            setFileName(file.name);
            onFileDrop(file);
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    return (
        <div
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            className='content-center justify-center p-3 border-dashed border-2 border-searchclr'
        >
            <FileInput onFileSelect={onFileSelect} />
            {fileName ?<span className='mt-10'> File Name: {fileName} </span>: null}
        </div>
    );
};

export default DragAndDrop;